// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__N-HlI","rootMobile":"styles_rootMobile__2XsDt"};